// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCarousel from 'vue-carousel'
import VueResource from 'vue-resource'
import VueProgressiveImage from 'vue-progressive-image'
import infiniteScroll from 'vue-infinite-scroll'
var SocialSharing = require('vue-social-sharing');

Vue.use(SocialSharing);





Vue.use(infiniteScroll)
Vue.use(VueProgressiveImage)
Vue.use(VueResource);
Vue.use(VueCarousel);

Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true;


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js